import { ISummary, ISummaryStory } from 'store/ticket-service/types';

import { GeneralStepConversationTopics } from 'core/enums/common';

export const getIsActiveTicketHasEmptyScenariosOrCriteria = (
	activeTicketSummaries: ISummary | undefined,
	param: keyof Pick<ISummaryStory, 'summaryAcceptanceCriteria' | 'summaryScenarios'>,
	activeSubStage?: GeneralStepConversationTopics
): boolean => {
	if (!activeTicketSummaries) return false;

	// const hasEmptyStoriesWithParam = activeTicketSummaries?.some((ticket) => {
	// 	const paramLength = ticket?.[param]?.length || 0;

	// 	const hasActiveSubStage = activeSubStage ? ticket.subStage === activeSubStage : true;

	// 	return hasActiveSubStage && !paramLength;
	// });

	
	// Filter summaries for the current substage if specified
    const relevantSummaries = activeSubStage 
        ? activeTicketSummaries.filter(ticket => ticket.subStage === activeSubStage)
        : activeTicketSummaries;

    // If there are no stories for this substage, return false
    if (relevantSummaries.length === 0) return false;

    // Check if any of the relevant stories have empty parameters
    const hasEmptyStoriesWithParam = relevantSummaries.some((ticket) => {
        const paramLength = ticket?.[param]?.length || 0;
        return !paramLength;
    });


	return hasEmptyStoriesWithParam;
};
